import { c as _c } from "react/compiler-runtime";
import { EntityPlacementCtaTypeEnum } from '@cc-shopping/contracts/cross-site/marketplace/enums';
import { CTASearchParams } from '@cc-shopping/platform-analytics/lib/ctaSearchParams';
import { FinishType } from '@cc-shopping/platform-analytics/types';
import { CdnImage, IMAGE_SIZES } from '@cc-shopping/ui/primitives/CdnImage';
import { Link } from '@mui/material';
import { CtaLink } from 'src/features/product-card/CTA/CtaLink';
import type { MiniProductCardProps } from '..';
type MiniProductCardCardImageProps = {
  marketplaceEntity: MiniProductCardProps['marketplaceEntity'];
  source: string;
  blockImageClick: boolean;
  href?: string;
};
export default function MiniProductCardCardImage(t0) {
  const $ = _c(16);
  const {
    marketplaceEntity,
    source,
    blockImageClick,
    href
  } = t0;
  const {
    cta,
    ctaAnalytics
  } = marketplaceEntity;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      objectFit: "contain" as const,
      objectPosition: "top",
      mixBlendMode: "multiply" as const
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== source) {
    t2 = {
      fill: true,
      alt: "product-card-image",
      src: source,
      sizes: IMAGE_SIZES.MINI_PRODUCT_CARD,
      style: t1
    };
    $[1] = source;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const imageProps = t2;
  if (blockImageClick) {
    let t3;
    if ($[3] !== imageProps) {
      t3 = <CdnImage {...imageProps} />;
      $[3] = imageProps;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    return t3;
  }
  if (!href) {
    return null;
  }
  const t3 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? "nofollow" : undefined;
  let t4;
  if ($[5] !== cta.type) {
    t4 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? [CTASearchParams.MONETIZING, CTASearchParams.SHOPPING_FINISH] : [];
    $[5] = cta.type;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const t5 = cta.type === EntityPlacementCtaTypeEnum.ApplyNow ? FinishType.ExternalApplication : FinishType.InternalContent;
  let t6;
  if ($[7] !== imageProps) {
    t6 = <CdnImage {...imageProps} />;
    $[7] = imageProps;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== ctaAnalytics || $[10] !== href || $[11] !== t3 || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = <CtaLink Component={Link} href={href} rel={t3} target="_blank" analytics={ctaAnalytics} parameterActions={t4} type="PRODUCT_IMAGE" finishType={t5}>{t6}</CtaLink>;
    $[9] = ctaAnalytics;
    $[10] = href;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  return t7;
}